import React from 'react';
import ScheduleZoneField, { defaultScheduleZone } from '../../shared/ScheduleZoneField';

// Spec §6.2 step 4 — schedule + refresh mode (replace/append) + target table/dataset.
// Hourly cadence is only allowed for query_structured_data per §6.2.
const StepSchedule = ({ formData, onSetFormData }) => {
  const schedule = formData.schedule || {};
  const allowHourly = formData.toolHint === 'query_structured_data';

  const updateSchedule = (patch) => onSetFormData({ ...formData, schedule: { ...schedule, ...patch } });

  return (
    <div className="push-step-content">
      <h3 className="push-step-title">Step 4 — Schedule and target</h3>

      <label className="push-label">Frequency</label>
      <select
        className="resui-select"
        value={schedule.frequency || 'daily'}
        onChange={(e) => updateSchedule({ frequency: e.target.value })}
        data-testid="push-frequency"
      >
        {allowHourly && <option value="hourly">Hourly</option>}
        <option value="daily">Daily</option>
        <option value="weekly">Weekly</option>
        <option value="monthly">Monthly</option>
      </select>
      {!allowHourly && (
        <p className="push-step-helper">Hourly cadence is only available for query_structured_data.</p>
      )}

      {schedule.frequency === 'weekly' && (
        <>
          <label className="push-label">Day of week</label>
          <select
            className="resui-select"
            value={schedule.dayOfWeek || 'monday'}
            onChange={(e) => updateSchedule({ dayOfWeek: e.target.value })}
          >
            <option value="monday">Monday</option>
            <option value="tuesday">Tuesday</option>
            <option value="wednesday">Wednesday</option>
            <option value="thursday">Thursday</option>
            <option value="friday">Friday</option>
            <option value="saturday">Saturday</option>
            <option value="sunday">Sunday</option>
          </select>
        </>
      )}

      {schedule.frequency !== 'hourly' && (
        <>
          <label className="push-label">Time</label>
          <input
            type="time"
            className="resui-input"
            value={schedule.time || '08:00'}
            onChange={(e) => updateSchedule({ time: e.target.value })}
          />
          <ScheduleZoneField
            value={formData.timezone || defaultScheduleZone()}
            onChange={(timezone) => onSetFormData({ ...formData, timezone })}
          />
        </>
      )}

      <label className="push-label">Refresh mode</label>
      <div className="push-radio-group" data-testid="push-refresh-mode">
        <label className="resui-radio">
          <input
            type="radio"
            className="resui-radio-input"
            name="refreshMode"
            value="replace"
            checked={formData.refreshMode === 'replace'}
            onChange={() => onSetFormData({ ...formData, refreshMode: 'replace' })}
          />
          <span className="resui-radio-mark" />
          <span className="resui-radio-label">Replace — overwrite the target each run</span>
        </label>
        <label className="resui-radio">
          <input
            type="radio"
            className="resui-radio-input"
            name="refreshMode"
            value="append"
            checked={formData.refreshMode === 'append'}
            onChange={() => onSetFormData({ ...formData, refreshMode: 'append' })}
          />
          <span className="resui-radio-mark" />
          <span className="resui-radio-label">Append — add new rows each run</span>
        </label>
      </div>

      <label className="push-label">Target table</label>
      <input
        className="resui-input"
        value={formData.targetTable}
        onChange={(e) => onSetFormData({ ...formData, targetTable: e.target.value })}
        placeholder="e.g. encounters_daily"
        data-testid="push-target-table"
      />

      <label className="push-label">Target dataset (optional)</label>
      <input
        className="resui-input"
        value={formData.targetDataset}
        onChange={(e) => onSetFormData({ ...formData, targetDataset: e.target.value })}
        placeholder="e.g. finance_dataset"
      />
    </div>
  );
};

export default StepSchedule;
